import { BulbFilled, BulbOutlined } from "@ant-design/icons";
import { Switch } from "antd";
import React from "react";
import { useTheme } from "themes/useTheme";

interface Props {
  style?: React.CSSProperties;
}

const ThemeSwitcher = (props: Props) => {
  const { theme, setTheme } = useTheme();

  return (
    <Switch
      onChange={(value) => {
        setTheme(value ? "dark" : "light");
      }}
      checkedChildren={<BulbOutlined />}
      unCheckedChildren={<BulbFilled style={{ color: "yellow" }} />}
      checked={theme === "dark"}
      style={Object.assign(
        { backgroundColor: theme === "dark" ? "grey" : undefined },
        props?.style || {}
      )}
    />
  );
};

export default ThemeSwitcher;
